__turbopack_context__.v({
  "pinInputInput": "OtpInput-module__E3siTG__pinInputInput",
  "pinInputRoot": "OtpInput-module__E3siTG__pinInputRoot",
});
